import { Component } from '@opten/compiler/metadata/component';
import {addClass} from '@opten/dom/add-class';
import {hasClass} from '@opten/dom/has-class';

declare const mixitup;

export class FilterMixitupOptions {
	activeClass: string;
	filterAttribute: string;
	selectors: {
		filter: string;
		element: string;
	}
}

@Component({ className: 'js-mixitup' })
export class MixitupComponent {
	private _options = {
		selectors: {
			filter: '.js-mixitup-filter',
			element: '.js-mixitup-item'
		}
	};
	private _filters: HTMLElement[];

	private _mixer: any;
	private _element: HTMLElement;
	constructor(public element: HTMLElement) {
		this._element = element;
		this._filters = Array.from(element.querySelectorAll(this._options.selectors.filter)) as HTMLElement[];
		this.init();
	}

	private init() {
		if (this._filters.length > 0) {
			this._mixer = mixitup(this._element, {
				selectors: {
					target: this._options.selectors.element,
					control: this._options.selectors.filter
				},
				classNames: {
					block: '',
					elementFilter: 'is'
				},
				load: {
					filter: this._filters[0].getAttribute('data-filter')
				},
				controls: {
					scope: 'local'
				},
				animation: {
					duration: 400
				}
			});
		}
	}
}